import { Terminal } from './../types/enums'

/**
 * Stores the users active terminal in local storage.
 * @param {Terminal} terminal - The terminal to store.
 */
export function setStoredTerminal(terminal: Terminal): void {
  localStorage.setItem('LeShuttle.Departures.ActiveTerminal', terminal)
}

/**
 * Retrieves the users active terminal from local storage.
 * If the terminal is not available, uses default terminal instead.
 * @param {Terminal} defaultTerminal - The default terminal.
 * @returns {Terminal} Stored terminal value or default terminal if unavailable.
 */
export function getStoredTerminal(defaultTerminal: Terminal): Terminal {
  const storedTerminal =
    localStorage.getItem('LeShuttle.Departures.ActiveTerminal') || ''

  if (
    storedTerminal !== null &&
    Object.values(Terminal).includes(storedTerminal as Terminal)
  ) {
    return storedTerminal as Terminal
  }

  return defaultTerminal
}
